import { createContext, type ReactNode, useContext } from 'react'

const SEPARATOR = ' › '

const NetworkDebugSourceContext = createContext<string | null>(null)

interface INetworkDebugSourceProps {
  /** The widget, section or component, e.g. `Acknowledgment window`. */
  name: string
  children: ReactNode
}

/**
 * Names the place the requests below it are made for, so the network data window can say where a
 * request came from. Nested sources add up: `Manager cockpit › Plan completeness › Acknowledgment
 * window`.
 */
export const NetworkDebugSource = ({ name, children }: INetworkDebugSourceProps) => {
  const parent = useContext(NetworkDebugSourceContext)

  return (
    <NetworkDebugSourceContext.Provider value={parent ? `${parent}${SEPARATOR}${name}` : name}>
      {children}
    </NetworkDebugSourceContext.Provider>
  )
}

/** The place the calling component stands in, for a fetcher to record with its request. */
export const useNetworkDebugSource = () => useContext(NetworkDebugSourceContext)
